//LOCAL <-> DEPLOY (.env.local <-> .env.production)
export const API_BASE_URL = process.env.REACT_APP_API_ROOT;
export const HOME_URL = process.env.REACT_APP_HOME_URL;
